import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";

export default function RequireAuth({ children, requireOrg = true }) {
  const { user, org, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-sm text-[#3B424B]" data-testid="auth-loading">Loading…</div>;
  }
  if (!user) return <Navigate to="/signin" state={{ from: location.pathname }} replace />;
  if (requireOrg && !org && location.pathname !== "/app/onboarding") {
    return <Navigate to="/app/onboarding" replace />;
  }
  return children;
}
